<template>
  <v-flex xs12 class="mb-4 px-5">
    <v-card>
      <v-card-title class="grey  lighten-2 mb-2">
        <span class="subtitle-1 font-weight-bold"
          >Indicative Quote <span v-if="quote.reference">Ref: {{ quote.reference }}</span></span
        >
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row class="px-5 subtitle-1 font-weight-bold">
            <v-col class="py-0 table-header" v-if="productType.name === 'Overdraft'">EAR</v-col>
            <v-col class="py-0 table-header" v-else>APR</v-col>
            <v-col class="py-0 table-header">Interest Rate</v-col>
            <v-col class="py-0 table-header" v-if="productType.name === 'Overdraft'">Annual Fee</v-col>
            <v-col class="py-0 table-header" v-else>Total Repayable</v-col>
            <v-col class="py-0 table-header" v-if="productType.name !== 'Overdraft'">Monthly Loan Repayments</v-col>
            <v-col class="py-0 text-center">Likelihood</v-col>
          </v-row>
          <v-row class="px-5 title text-left">
            <v-col class="py-0">{{ quote.interest_rate }}%</v-col>
            <v-col class="py-0">{{ quote.interest_margin }}%</v-col>
            <v-col class="py-0" v-if="productType.name === 'Overdraft'">{{ quote.annual_fee | currency }}</v-col>
            <v-col class="py-0" v-else>{{ quote.total_payable | currency }}</v-col>
            <v-col class="py-0" v-if="productType.name !== 'Overdraft'">{{ quote.monthly_repayment | currency }}</v-col>
            <v-col class="py-0 text-center">
              <v-progress-circular :rotate="-90" :size="50" :width="7" :value="quote.likelihood" :color="colour">
                {{ quote.likelihood }}
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'EnquiryQuote',
  props: ['quote', 'productType'],
  computed: {
    colour: function() {
      if (this.quote.likelihood > 50 && this.quote.success) {
        return 'green';
      } else if (this.quote.likelihood > 15 && this.quote.success) {
        return 'amber';
      } else {
        return 'error';
      }
    }
  },
  filters: {
    currency: function(value) {
      const intValue = _.isNaN(parseFloat(value)) ? 0 : parseFloat(value);

      return (
        '£' +
        intValue.toLocaleString({
          style: 'currency',
          currency: 'GBP',
          currencyDisplay: 'symbol',
          minimumSignificantDigits: 2,
          maximumSignificantDigits: 2
        })
      );
    }
  }
};
</script>

<style scoped>
.table-header {
  line-height: 1.4;
}
</style>
